export default "__VITE_ASSET__BuqWZOrp__"